export default {
    nav: {
        home: "Home",
        block: "Block Chain",
        viewblock: "View Block",
        viewtx: "View Transaction",
        token: "Token",
        rank: " Ranking",
        node: "Node",
        tool: "Tools",
        analysis: "Tx Analysis",
        broadcast: "Tx Broadcast",
    },
    footer: {
        txt:
            "BitYuan Explorer is a platform for block data inquiry and analysis.",
        linkTitle: "Links",
        bty: "BitYuan",
        wallet: "Bwallet",
    },
    page: {
        first: "First Page",
        last: "Last Page",
        confirm: "Confirm",
        nodata: "No Data",
    },
    components: {
        hour: " hr ",
        hours: " hrs ",
        min: " min ",
        mins: " mins ",
        sec: " sec ago",
        secs: " secs ago",
        copy: "Copy",
        tip: "Tip",
        noMsg: "No transaction information was found",
        repeat: "Repeat",
        copySuc: "Copy Succeeded",
        copyErr: "Copy Error",
        allBlock: "All Blocks",
        blockDetail: "Block Details",
        succ: "Succeed",
        fail: "Fail",
        errMsg: "Incorrect input, please reenter",
        errAdr: "Address Error",
        errParam: "Incorrect parameter input!",
        errToken: "No such token!",
        errRequest: "Data request failed!",
        errTxt: "Transaction text can’t be blank!",
        errHeight:
            "The block height entered cannot exceed the current maximum height",
        errFormat:
            "Format error, please complete the transaction text in hexadecimal format!",
        footer: "Is a platform for block data inquiry and analysis.",
    },
    home: {
        title: "BitYuan Block Chain Explorer",
        banner: "  BitYuan Explorer",
        keyword: "Please enter Address/TxHash/Block Height/DNS",
        search: "Search",
        blockTitle: "Latest Blocks",
        txCount: "Transaction Quantity",
        time: "Time",
        txTitle: "Latest Transactions",
        txHash: "Txn Hash",
        sender: "Sender",
        receiver: "Receiver",
        txValue: "Txn Value",
        viewAll: "View All",
        mineRevenue: "Mining Revenue",
        miner: "Miner",
        minerAdr: "Miner address",
        fund: "Development Fund",
        txs: "Txns",
        tx: "Txn",
        bi: "Txns",
        nPrice: "Current Price",
        nNum: "Total Value",
        nMValue: "Market Cap",
        avgspeed: "Average Block Time",
        perTxns: "Txns per second",
        burnQuotes: "Burning Quotes",
        priceQuotes: "Price Quotes",
        burnCount: "Burn Amount",
    },
    block: {
        title: "All Blocks",
        count: " Blocks",
        height: "Height",
        time: "Time",
        hash: "Block Hash",
        txCount: "Transaction Quantity",
        blockRevenue: "Block Revenue",
    },
    blockDetail: {
        title: "Block Height",
        general: "Overview",
        last: "Last Block",
        next: "Next Block",
        mock: "Merkel Root",
        statusHash: "Status Hash",
        record: "Transaction Record",
        nodata: "No Data",
    },
    trade: {
        title: "All Transactions",
        count: " Transactions",
        totalTip: "All ",
        tip: "Show the last 100,000 records",
        hash: "Transaction Hash",
        sender: "Sender",
        receiver: "Receiver",
        num: "Value",
        fee: "Fee",
        func: "Invoke Function",
        time: "Time",
        token: "Token",
    },
    txDetail: {
        title: "Transaction Details",
        status: "Status",
        success: "succeeded",
        faild: "Read-in succeeded, execution failed",
        value: "Value",
        random: "Random Number",
        execer: "Executor",
        txType: "Transaction Type",
        normalTx: "Normal Transaction",
        groupTx: "Transaction Group",
        inData: "Input Data",
        outData: "Output Data",
    },
    address: {
        nav: "Personal Address",
        title: "Address",
        tag: "Tag",
        dns: "To bind",
        save: "Save QR Code",
        balance: "Balance",
        placeholder: "Please select a contract",
        frozen: "Frozen",
        txCount: "Txns number",
        total: "Token Value",
        about: "About",
        treceive: "Received",
        tsent: "Sent",
        tokenPlaceholder: "Please enter token name",
        record: "Transaction Record",
        tokenRecord: "Token Transaction Record",
        txTotal: "{0} transaction(s) found in total",
        last: "Show the last {0} records",
        allTx: "All Transactions",
        succTx: "View all successful transactions",
        failTx: "View all failed transactions ",
        sendTx: "View all transactions sent",
        receTx: "View all transactions received",
    },
    token: {
        title: "Token",
        mainToken: "Main Token",
        holder: "Holder",
        time: "Time",
        introduce: "Token Introduction",
        tokenList: "Token List",
        keyword: "Please enter token name",
        total: "{0} token(s) in total",
        id: "ID",
    },
    tokenDetail: {
        title: "Token Details",
        issueTotal: "Total Issue Quantity",
        holder: "Holder",
        issueTime: "Issue Time",
        point: "Point ",
        value: "Value",
        screen: "Screen by token holder",
        viewChart: "View Chart",
    },
    node: {
        title: "Global BTY nodes status",
        tip:
            "The map shows the distribution of BTY nodes in different countries and area.",
        count: "{0} nodes in total",
        time: "As of {0} (UTC/GMT +08:00)",
    },
    rank: {
        title: "Holder",
        holdingNum: "Holding Quantity",
        range: "Range",
        best: "Best ",
        type: "Type",
        token: "Token ",
        holdingRank: "Token Holding Ranking",
        mineRank: "Mining Ranking",
        topHolder: "Holder of the best {0} holds about {2} of {1}",
        totalTip: "Total Token Supply",
        holderTip: "Total Token Holders",
        ps:
            "Note: total {1} token held by the best {0} account are from total supply of {2} token",
        rank: "Ranking",
        adr: "Address",
        num: "Number",
        percent: "Percentage",
        contractAdr: "Contract address",
    },
    analysis: {
        title: "Transaction Analysis",
        tip:
            "You can enter an unsigned source transaction on this page, text in hexadecimal format, which will be analyzed into a readable format.",
    },
    broadcast: {
        title: "Transaction Broadcast",
        tip:
            "You can enter an signed source transaction on this page, text in hexadecimal format, which will be analyzed into a readable format.",
        ps:
            "You are advised to check your transaction text before transaction broadcast.",
        notice: "Notice：",
        link: "Go to Transaction Analysis",
        btn: "Send Transaction",
    },
};
